const PRICING_POPUP_TYPES = {
  featuresProperties: "featuresProperties",
  featureGroups: "featureGroups",
  allCatalogs: "allCatalogs",
  assignFeatures: "assignFeatures",
}

export default PRICING_POPUP_TYPES
